import { useGame } from '@0g/react';
import * as React from 'react';
import { Button } from './components/Button';
import { useStore } from './useStore';
export function AddEntityButton() {
    var game = useGame();
    var select = useStore(function (s) { return s.api.selectEntity; });
    var addEntity = React.useCallback(function () {
        var e = game.create();
        select(e);
    }, [game, select]);
    return React.createElement(Button, { onClick: addEntity }, "Add Entity");
}
//# sourceMappingURL=AddEntityButton.js.map